/* ======== Globals ========= */
import { create } from "zustand";

import { customConstants } from "../configs/custom-app-config";
import type { CustomConfigType } from "../configs/custom-app-config-schema";
import { buildType } from "../helpers/expo-extras";
/* ======== Types ========= */
import type { Apps } from "../types/apps";

/* ======== Store Creation ========= */
interface AppState extends CustomConfigType {
	setAppConfig: (appConfig: CustomConfigType) => void;
}

const appConfig = customConstants[buildType as Apps];

export const useAppStore = create<AppState>((set) => ({
	...appConfig,
	setAppConfig: (appConfig) => set((state) => ({ ...state, ...appConfig })),
}));
